import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLargeExtendedRent = function SvgLargeExtendedRent(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 69 69",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M31.55 10.07a2.5 2.5 0 012.5-2.5c14.602 0 26.439 11.836 26.439 26.438 0 14.602-11.837 26.439-26.44 26.439-14.601 0-26.438-11.837-26.438-26.439a2.5 2.5 0 115 0c0 11.84 9.598 21.439 21.439 21.439 11.84 0 21.439-9.599 21.439-21.439S45.89 12.57 34.049 12.57a2.5 2.5 0 01-2.5-2.5z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.359 26.497a2.5 2.5 0 01-1.258-3.294 26.507 26.507 0 0111.772-12.616 2.5 2.5 0 013.39 1.05l11.078 21.214a2.5 2.5 0 01-3.242 3.437l-21.74-9.79z",
    clipRule: "evenodd"
  }));
};

export default SvgLargeExtendedRent;